/**
 * One entry of the trucking whitelist. A rate is quoted only if some rule allows it, and every
 * qualifier left undefined matches anything — so `{ scac: 'SEFL' }` allows SEFL through every
 * broker, on every integration, into every origin, for every fulfillment partner.
 */
export type TruckingWhitelistRule = {
  /** The entry exactly as it was typed, so a decision can name the rule responsible */
  raw?: string;
  isDeny: boolean;
  /** Undefined matches every carrier, written `*` */
  scac?: string;
  broker?: string;
  /** The integration the rate came from, one of `TRUCKING_PROVIDERS` */
  integration?: string;
  /** IATA code of the origin airport the truck delivers into */
  origin?: string;
  fpAccountId?: number;
};

/** Written in place of a SCAC to match every carrier */
export const ANY_CARRIER = '*';

/** `[!]SCAC[/broker][:integration][@origin][#fpAccountId]` — see docs/trucking-whitelist.md */
export const RULE_PATTERN =
  /^(!?)\s*([A-Za-z0-9]{2,10}|\*)\s*(?:\/\s*([^,@#:\n;]+?))?\s*(?::\s*([A-Za-z]+))?\s*(?:@\s*([A-Za-z]{3}))?\s*(?:#\s*(\d+))?\s*$/;
